import React from 'react'
import appleShop  from '../img/newAppModal/apple.png'
import androidShop  from '../img/newAppModal/android.png'
import content  from '../img/newAppModal/content.png'

const NewApp = () => {
  return (
    <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: 8}}> 
        <h1 style={{maxWidth: 800, textAlign: 'center'}}>Máme pro Vás novou vymazlenou APPku, stahujte ve svém marketu</h1>
        <img src={content} class="newAppIcon" style={{maxWidth: 250}} />

        <a href="https://apps.apple.com/cz/app/global-plus/id6502606357?l=cs" style={{maxWidth: 300}}>
            <img src={appleShop} class="newAppIcon"/>
        </a>
        <a href={"https://play.google.com/store/apps/details?id=com.cubos.GlobalPlus&hl=cs"} style={{maxWidth: 300}}>
            <img src={androidShop} class="newAppIcon"/>
        </a>
           
    </div>
  )
}

export default NewApp
